import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({ providedIn: 'root' })
export class BrowserService {
  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}
  /** Returns true if running in browser */
  get isBrowser(): boolean {
    return isPlatformBrowser(this.platformId);
  }
 
  /** Returns true if running on server */
  get isServer(): boolean {
    return !this.isBrowser;
  }
 
  /** Safe window object - returns null during SSR */
  get window(): Window | null {
    return this.isBrowser ? window : null;
  }
 
  /** Safe document object - returns null during SSR */
  get doc(): Document | null {
    return this.isBrowser ? document : null;
  }
 
  /** Safe localStorage - returns null during SSR */
  get localStorage(): Storage | null {
    return this.isBrowser ? localStorage : null;
  }
 
  /** Safe sessionStorage - returns null during SSR */
  get sessionStorage(): Storage | null {
    return this.isBrowser ? sessionStorage : null;
  }
 
  /** Safe navigator - returns null during SSR */
  get navigator(): Navigator | null {
    return this.isBrowser ? navigator : null;
  }
 
  /** Safe location - returns null during SSR */
  get location(): Location | null {
    return this.isBrowser ? window.location : null;
  }
 
  /** Safe history - returns null during SSR */
  get history(): History | null {
    return this.isBrowser ? window.history : null;
  }
 
  /** Execute a callback only in browser environment */
  runInBrowser(callback: () => void): void {
    if (this.isBrowser) {
      callback();
    }
  }
 
  /** Get a browser value with a fallback for SSR */
  browserValue<T>(fn: () => T, fallback: T): T {
    return this.isBrowser ? fn() : fallback;
  }
}